export default [
  {
    text: 'sync.table.id',
    value: 'id',
    default: true,
    align: 'left',
  },
];
